import { Auth } from 'types'
import { sendToApi } from 'api/client'
import { WorkspaceDomainAttributes } from './WorkspaceDomainClientUtils'

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const url = process.env.REACT_APP_READER_URL! as string

const READER_URL = new URL(url)

export const WorkspaceDomainClient = {
  checkAvailability: (workspaceDomainAttributes: WorkspaceDomainAttributes) =>
    sendToApi<boolean>('/workspace_domains/check_availability', { params: { ...workspaceDomainAttributes } }),
  createCertificate: (id: number) => sendToApi<void>(`/workspace_domains/${id}/certificates`, { method: 'POST' }),
  createCookie: (domain: string, auth: Auth, redirectTo: string, urlSearchParams: URLSearchParams) => {
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = `${domain}${READER_URL.port.length ? `:${READER_URL.port}` : ''}/v1/workspace_domains/cookies`

    const authField = document.createElement('input')
    authField.type = 'hidden'
    authField.name = 'auth'
    authField.value = JSON.stringify(auth)

    const redirectToField = document.createElement('input')
    redirectToField.type = 'hidden'
    redirectToField.name = 'redirect_to'
    redirectToField.value = `${redirectTo}?${urlSearchParams.toString()}`

    document.body.appendChild(form)
    form.appendChild(authField)
    form.appendChild(redirectToField)

    form.submit()
  },
}
